import { Autocomplete, FormControl, FormHelperText, TextField } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import type { UseMakeSortedSegmentFields } from "../hooks/use-sorted-segment-fields";
import type { Condition } from "../types";

export const ConditionField: FC<{
  segmentFields: ReturnType<UseMakeSortedSegmentFields>["fields"];

  groupingFn: ReturnType<UseMakeSortedSegmentFields>["groupingFn"];
  condition: Condition;
  handleFieldChange: (value: Partial<Condition>) => void;
  disabled?: boolean;
  errMsg?: string;
}> = ({ segmentFields, groupingFn, condition, handleFieldChange, disabled, errMsg }) => {
  const { t } = useTranslation();

  return (
    <FormControl sx={{ mr: 1 }} fullWidth error={Boolean(errMsg)}>
      <Autocomplete
        disablePortal={false}
        fullWidth
        size="small"
        options={segmentFields}
        getOptionLabel={(option) => option.display_name}
        getOptionDisabled={(option) => option.disabled}
        groupBy={groupingFn}
        onChange={(_, value) => {
          if (!value) return;

          handleFieldChange({ field: value.key });
        }}
        value={segmentFields.find((f) => f.key === condition.field) ?? segmentFields[0]}
        disabled={disabled}
        renderInput={(params) => <TextField {...params} label={t("Field")} variant="outlined" />}
      />
      {Boolean(errMsg) && <FormHelperText>{errMsg}</FormHelperText>}
    </FormControl>
  );
};
